const f = {
  color: {
    background: "#f9fafaff",
    border: "#d5dce1",
    operator: {
      background: "#abb9c7ff"
    },
    text: "#405261ff",
    selected: {
      text: "#314351ff"
    }
  }
};
export {
  f as condition
};
